import { MapPin, Phone, Mail, Clock } from "lucide-react";
import { useSettings } from "../lib/settings";
import { QuoteForm } from "../components/QuoteForm";
import { Reveal } from "../components/Reveal";
import { usePageMeta } from "@/hooks/use-page-meta";
import { InstagramLogo, WhatsAppLogo } from "../components/BrandIcons";

export default function Contact() {
  usePageMeta({ title: "İletişim", description: "VIA PRIME Luxury ile iletişime geçin, kurumsal filo kiralama için hızlı teklif alın." });
  const CONTACT = useSettings();
  const items = [
    { icon: MapPin, label: "Ofis", value: CONTACT.address, testid: "contact-address" },
    { icon: Phone, label: "Telefon", value: CONTACT.phone, href: `tel:${CONTACT.phone.replace(/\s/g, "")}`, testid: "contact-phone" },
    { icon: Mail, label: "E-posta", value: CONTACT.email, href: `mailto:${CONTACT.email}`, testid: "contact-email" },
    { icon: Clock, label: "Çalışma Saatleri", value: CONTACT.hours, testid: "contact-hours" },
  ];

  return (
    <div className="py-20 px-6" data-testid="contact-page">
      <div className="max-w-6xl mx-auto">
        <Reveal>
          <span className="text-xs font-mono-lbl uppercase tracking-widest text-[#8F7648]">
            Contact
          </span>
          <h1 className="text-4xl md:text-6xl font-serif-display text-[#404040] mt-2">
            İletişim
          </h1>
          <p className="text-sm text-[#6B6B6B] mt-4">
            Prestij yolculuğunuz için bize ulaşın.
          </p>
        </Reveal>

        <div className="grid grid-cols-1 lg:grid-cols-5 gap-10 mt-14">
          <Reveal className="lg:col-span-2">
            <div className="space-y-4">
              {items.map((item) => (
                <div
                  key={item.label}
                  data-testid={item.testid}
                  className="rounded-sm bg-white shadow-[0_4px_20px_rgba(176,144,96,0.05)] border border-[#B09060]/20 p-5 flex items-start gap-4"
                >
                  <item.icon className="w-5 h-5 text-[#8F7648] mt-0.5 shrink-0" />
                  <div>
                    <div className="text-[10px] font-mono-lbl uppercase tracking-widest text-[#9B9B8F]">
                      {item.label}
                    </div>
                    {item.href ? (
                      <a href={item.href} className="text-sm text-[#404040] mt-1 block hover:text-[#B09060] transition-colors">
                        {item.value}
                      </a>
                    ) : (
                      <div className="text-sm text-[#404040] mt-1">{item.value}</div>
                    )}
                  </div>
                </div>
              ))}

              <a
                href={CONTACT.whatsapp}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="contact-whatsapp-cta"
                className="rounded-sm border border-[#25D366]/40 bg-[#25D366]/10 p-5 flex items-center gap-4 hover:bg-[#25D366]/20 transition-colors"
              >
                <WhatsAppLogo className="w-8 h-8 shrink-0" />
                <div>
                  <div className="text-sm text-[#128C4B] font-bold">WhatsApp</div>
                  <div className="text-[10px] font-mono-lbl uppercase tracking-widest text-[#6B6B6B] mt-0.5">
                    Anında İletişim
                  </div>
                </div>
              </a>

              {CONTACT.instagram && (
                <a
                  href={CONTACT.instagram}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="contact-instagram-cta"
                  className="rounded-sm border border-[#B09060]/40 bg-[#B09060]/10 p-5 flex items-center gap-4 hover:bg-[#B09060]/20 transition-colors"
                >
                  <InstagramLogo className="w-8 h-8 shrink-0" />
                  <div>
                    <div className="text-sm text-[#B09060] font-bold">Instagram</div>
                    <div className="text-[10px] font-mono-lbl uppercase tracking-widest text-[#6B6B6B] mt-0.5">
                      @{CONTACT.instagram.replace(/\/+$/, "").split("/").pop()}
                    </div>
                  </div>
                </a>
              )}
            </div>
          </Reveal>

          <Reveal delay={0.15} className="lg:col-span-3">
            <div>
              <h2 className="text-2xl font-serif-display text-[#404040] mb-6">Teklif Formu</h2>
              <QuoteForm formType="teklif" />
            </div>
          </Reveal>
        </div>
      </div>
    </div>
  );
}
